import useIPA from '@/auth/jwt/useDevice'
import router from '@/router/index.js'

// initial state
const state = () => ({
  province: [],
  regency: [],
  district: [],
  village: [],
  site: [],
  area: [],
  location: [],
  columns: [
    {
      label: 'Name', field: 'name'
    },
    {
      label: 'Description', field: 'desc'
    },
    {
      label: 'Action', field: 'action'
    }
  ],
  pages: []
})

// getters
const getters = {}

// actions
const actions = {
  province ({ commit }) {
    let param = {status: '/internal/master/provinces'}
    useIPA.getGlobe(param).then(response => {
      commit('setProvince', response.data.data)
    })
  },
  regency ({ commit }, id) {
    let param = {status: '/internal/master/regencies?&prov_id=' + id}
    useIPA.getGlobe(param).then(response => {
      commit('setRegency', response.data.data)
    })
  },
  district ({ commit }, id) {
    let param = {status: '/internal/master/districts?&rgcy_id=' + id}
    useIPA.getGlobe(param).then(response => {
      commit('setDistrict', response.data.data)
    })
  },
  village ({ commit }, id) {
    let param = {status: 'region/villages/district/' + id}
    useIPA.getGlobe(param).then(response => {
      commit('setVillage', response.data.data)
    })
  },
  site ({ commit }, { province, regency, district }) {
    let param = {status: `region/site?province_id=${province}&regency_id${regency}&district=${district}`}
    useIPA.getGlobe(param).then(response => {
      commit('setSite', response.data.data)
    })
  },
  area ({ commit }, id) {
    let param = {status: 'internal/master/areas?site_id=' + id}
    useIPA.getGlobe(param).then(response => {
      commit('setArea', response.data.data)
    })
  },
  location ({ commit }, id) {
    let param = {status: 'internal/master/locations?area_id=' + id}
    useIPA.getGlobe(param).then(response => {
      commit('setLocation', response.data.data)
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/province/' + id}
      useIPA.getGlobe(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        name: formData.text_1,
        desc: formData.text_2
			}
      const param = { rawData: rawData, url: 'backoffice/master/province', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'province' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'backoffice/master/province', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setProvince (state, province) {
    state.province = []
    for (let i = 0; i < province.length; i++) {
      const option = []
      for (const key in province[i]) {
        if (key === 'id') { 
          option['value'] = province[i][key] 
        } else if (key === 'name') { 
          option['title'] = province[i][key] 
        } else if (key === 'id') { 
          option['oid'] = province[i][key] 
        } 
      }
      state.province.push(Object.assign({}, option))
    }
  },
  setRegency (state, regency) {
    state.regency = []
    for (let i = 0; i < regency.length; i++) {
      const option = []
      for (const key in regency[i]) {
        if (key === 'id') { 
          option['value'] = regency[i][key] 
        } else if (key === 'name') { 
          option['title'] = regency[i][key] 
        } else if (key === 'id') { 
          option['oid'] = regency[i][key] 
        } 
      }
      state.regency.push(Object.assign({}, option))
    }
  },
  setDistrict (state, district) {
    state.district = []
    for (let i = 0; i < district.length; i++) {
      const option = []
      for (const key in district[i]) {
        if (key === 'id') { 
          option['value'] = district[i][key] 
        } else if (key === 'name') { 
          option['title'] = district[i][key] 
        } else if (key === 'id') { 
          option['oid'] = district[i][key] 
        } 
      }
      state.district.push(Object.assign({}, option))
    }
  },
  setVillage (state, village) {
    state.village = []
    for (let i = 0; i < village.length; i++) {
      const option = []
      for (const key in village[i]) {
        if (key === 'id') { 
          option['value'] = village[i][key] 
        } else if (key === 'name') { 
          option['title'] = village[i][key] 
        } else if (key === 'id') { 
          option['oid'] = village[i][key] 
        } 
      }
      state.village.push(Object.assign({}, option))
    }
  },
  setSite (state, site) {
    state.site = []
    for (let i = 0; i < site.length; i++) {
      const option = []
      for (const key in site[i]) {
        if (key === 'id') { 
          option['value'] = site[i][key] 
        } else if (key === 'name') { 
          option['title'] = site[i][key] 
        } else if (key === 'id') { 
          option['oid'] = site[i][key] 
        } 
      }
      state.site.push(Object.assign({}, option))
    }
  },
  setArea (state, area) {
    state.area = []
    for (let i = 0; i < area.length; i++) {
      const option = []
      for (const key in area[i]) {
        if (key === 'id') { 
          option['value'] = area[i][key] 
        } else if (key === 'name') { 
          option['title'] = area[i][key] 
        } else if (key === 'id') { 
          option['oid'] = area[i][key] 
        } 
      }
      state.area.push(Object.assign({}, option))
    }
  },
  setLocation (state, location) {
    state.location = []
    for (let i = 0; i < location.length; i++) {
      const option = []
      for (const key in location[i]) {
        if (key === 'id') { 
          option['value'] = location[i][key] 
        } else if (key === 'name') { 
          option['title'] = location[i][key] 
        } else if (key === 'id') { 
          option['oid'] = location[i][key] 
        } 
      }
      state.location.push(Object.assign({}, option))
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
